export const FETCH_ALL_CONSULTATION = "fetch_all_consultation";
export const FETCH_ALL_CONSULTATION_SUCCESS = "fetch_all_consultation_success";
export const EDIT_CONSULTATION = "edit_consultation";
export const DELETE_CONSULTATION = "delete_consultation";
export const CREATE_CONSULTATION = "create_consultation";
export const CREATE_CONSULTATION_SUCCESS = "create_consultation_success";
export const UPDATE_CONSULTATION_SUCCESS = "update_consultation_success";
export const UPDATE_CONSULTATION = "update_consultation";
export const DELETE_CONSULTATION_SUCCESS = "delete_consultation_success";
export const SET_CONSULTATION = "set_consultation";
export const CONSULTATION_POPUP_STATUS_CHANGE =
  "consultation_popup_status_change";
export const FETCH_CHATS = "fetch_chats";
export const FETCH_CHATS_SUCCESS = "fetch_chats_success";
export const FETCH_CALLS = "fetch_calls";
export const FETCH_CALLS_SUCCESS = "fetch_calls_success";
export const FILTER_CONSULTATION = "filter_consultation";
export const FILTER_CONSULTATION_SUCCESS = "filter_consultation_success";
export const CREATE_CALL_EVENT_SUCCESS = "create_call_event_success";

